/* eslint-disable */
import type from 'type-detect'
import moment from 'moment'
import Vue from 'vue'

// state: the current state from the global storage
// initialState: the initial state as it comes freshly from the module
// path: just the name of the module (string) to have some better debug output
//       will be extended with the keys during recursion
export function repairState (state, initialState, path) {
  // Lets start with looking at every attribute in the current state
  for (const key in state) {
    // Skipp that one
    // The keys of this one are unknown, so we can't initiate it correctly
    if (key === 'tariffOptions') continue
    const stateType = type(state[key])
    const initialType = type(initialState[key])
    if (initialType === 'undefined') {
      // Drop every attribute that is no longer in the initialState
      delete (state[key])
    } else if (initialType === 'Object') {
      // Deep check every existing object
      // or simply set the attribute to the initial object
      state[key] = (stateType === 'Object')
        ? repairState(state[key], initialState[key], `${path}.${key}`)
        : initialState[key]
    } else if (initialType === 'Array') {
      // Make sure that arrays are arrays
      // So far the content will be ignored
      if (stateType !== 'Array') {
        state[key] = initialState[key]
      }
    }
  }

  // return the state for convenience
  return state
}

// state: the current state from the global storage
// initialState: the initial state as it comes freshly from the module
export function resetState (state, initialState) {
  let key
  // We don't expect to have a repaired state.
  // That's why we drop everything first.
  for (key in state) {
    delete (state[key])
  }
  // And then we initiate the state attribute by attribute
  // taking the reactivity into account
  for (key in initialState) {
    Vue.set(state, key, initialState[key])
  }
  // return the state for convenience
  return state
}

export function isValidDate(date) {
  return moment(date, 'DD.MM.YYYY', true).isValid()
}
